import { Home, PawPrint, Receipt, HeartPulse, Users, Briefcase, Plane, Cake, CalendarDays } from "lucide-react";

export const USERS = ["alexis", "emily"];
export const NAMES = { alexis: "Alexis", emily: "Emily" };
export const money = (c) => `${(c || 0) < 0 ? "-" : ""}$${(Math.abs(c || 0) / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
export const pts = (n) => { const v = Math.round((n || 0) * 100) / 100; return (v > 0 ? "+" : "") + v.toLocaleString(undefined, { maximumFractionDigits: 2 }); };
export const num = (n) => (Math.round((n || 0) * 100) / 100).toLocaleString(undefined, { maximumFractionDigits: 2 });
export const pad = (n) => String(n).padStart(2, "0");
export const ymd = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
export const parseYmd = (s) => { const [y, m, d] = s.split("-").map(Number); return new Date(y, m - 1, d); };
export const addDays = (d, n) => { const x = new Date(d); x.setDate(x.getDate() + n); return x; };
export const today = () => new Date().toLocaleDateString("en-CA", { timeZone: "America/New_York" });
export const fmtDate = (s, o = { month: "short", day: "numeric" }) => (s ? parseYmd(s.slice(0, 10)).toLocaleDateString(undefined, o) : "");
export const fmtTime = (t) => { if (!t) return ""; const [h, m] = t.split(":").map(Number); const d = new Date(); d.setHours(h, m); return d.toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" }); };
export const fmtStamp = (iso) => (iso ? new Date(iso).toLocaleString(undefined, { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" }) : "");
export const ago = (iso) => {
  const s = (Date.now() - new Date(iso).getTime()) / 1000;
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return fmtStamp(iso);
};
export const uid = () => (crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random()}`);

export const CATS = {
  general: { label: "General", color: "#9AA5B1", Icon: CalendarDays },
  home: { label: "Home", color: "#8A9A5B", Icon: Home },
  sparrow: { label: "Sparrow", color: "#C89662", Icon: PawPrint },
  bills: { label: "Bills", color: "#E0B354", Icon: Receipt },
  health: { label: "Health", color: "#6FB3A8", Icon: HeartPulse },
  social: { label: "Social", color: "#D8A0B3", Icon: Users },
  work: { label: "Work", color: "#7C93C3", Icon: Briefcase },
  travel: { label: "Travel", color: "#B48EDB", Icon: Plane },
  birthday: { label: "Birthday", color: "#E57373", Icon: Cake },
};
export const DIFF_LABEL = { easy: "Easy", medium: "Medium", hard: "Hard" };
export const BILL_CATS = ["housing", "utilities", "phone", "internet", "insurance", "subscriptions", "car", "loans", "credit", "sparrow", "health", "other"];
export const cap = (s) => (s ? s[0].toUpperCase() + s.slice(1) : "");
